<template>
  <div>
    <InputTextarea
      v-model="modelValue.emails"
      placeholder="E-mailadressen"
      @input="delayedUpdate.schedule()"
      @blur="v$.emails.$touch()"
      :errors="v$.emails.$errors"
    />
    <span class="text-xs"> Voer extra e-mailadressen in, gescheiden door puntkomma's.</span>

    <AutoUpdateStatus
      :is-updating="isSaving"
      :error-encountered="errorEncountered"
      :time-hide-after-success="2000"
    />
  </div>
</template>

<script setup lang="ts">
import type { RoleFinancialOfficer } from "@/models/role/role-financial-officer.model"
import { useRoleStore } from "@/store/roles.store"
import useDelayedFunction from "@/composables/input/delayed-function"
import useVuelidate from "@vuelidate/core"
import { multipleEmailsValidator } from "@/helper/validation/validators"
import AutoUpdateStatus from "@/components/instruction/AutoUpdateStatus.vue"
import { ref } from "vue"
import InputTextarea from "@/components/inputs/InputTextarea.vue"

const modelValue = defineModel<RoleFinancialOfficer>({ required: true })

const emit = defineEmits(["roleChanged"])

const roleStore = useRoleStore()

const delayedUpdate = useDelayedFunction(updateRole, 500)

const isSaving = ref(false)
const errorEncountered = ref(false)
async function updateRole() {
  errorEncountered.value = false
  if (v$.value.emails.$invalid) {
    return
  }

  isSaving.value = true
  const response = await roleStore.updateRole(modelValue.value)
  if (response.status !== 200) {
    errorEncountered.value = true
  }
  emit("roleChanged")
  isSaving.value = false
}

const rules = {
  emails: { multipleEmailsValidator }
}
const v$ = useVuelidate(rules, modelValue)
</script>

<style scoped></style>
